import request from "@/utils/request";

//赛事详情
export function getCompetitionDetail(params) {
  return request({
    url: `/client/competition/getDetail`,
    method: "get",
    params: params,
  });
}
//获取报名信息
export function getSignUpDetail(params) {
  return request({
    url: `/client/application/getDetail`,
    method: "get",
    params: params,
  });
}
//提交报名信息
export function commitApplication(data) {
  return request({
    url: `/client/application/commit`,
    method: "post",
    data: data,
  });
}
//获取首页banner列表
export function getHomeBannerList() {
  return request({
    url: `/client/home/getBannerList`,
    method: "get",
  });
}
//获赛事列表页面的banner列表
export function getCompetitionBannerList() {
  return request({
    url: `/client/competition/getBannerList`,
    method: "get",
  });
}
//风采展示列表
export function getShowBannerList() {
  return request({
    url: `/client/competition/getShowBannerList`,
    method: "get",
  });
}
//赛事列表
export function getCompetitionList(query) {
  return request({
    url: `/client/competition/getList`,
    method: "get",
    params: query,
  });
}
//获取考试链接
export function getExamUrl({ competitionId, examId }) {
  return request({
    url: `/client/examination/getExamUrl?competitionId=${competitionId}&examId=${examId}`,
    method: "get",
  });
}

export function getExaminationResult(competitionId) {
  return request({
    url: `/client/result/examinationResult?competitionId=${competitionId}`,
    method: "get",
  });
}

// 获取作品上传信息
export function getWorkInfo(competitionId) {
  return request({
    url: `/client/work/getWorkInfo?competitionId=${competitionId}`,
    method: "get",
  });
}

// 获取作品上传信息
export function uploadWork(data) {
  return request({
    url: `/client/file/upload`,
    method: "post",
    headers: {
      "Content-Type": "multipart/form-data",
    },
    data,
    // timeout: 10 * 60 * 1000,
  });
}

// 提交作品信息
export function saveWork(data) {
  return request({
    url: `/client/work/commit`,
    method: "post",
    data,
  });
}

// 获取上传token
export function getToken(fileName) {
  return request({
    url: `/client/file/getToken?fileName=${fileName}`,
    method: "get",
  });
}

// // 根据字典类型查询字典数据信息
export function getDicts(dictType) {
  return request({
    url: "/system/dict/data/type/" + dictType,
    method: "get",
  });
}
